import { Input } from '@builder.io/sdk';

import { buttonFields } from 'molecules/Button/config';
import { formFields } from 'molecules/Form/config';
import sectionFields, { SectionConfigProps } from 'molecules/Section/config';

export const resourceConversionPanelFields = [
  {
    name: 'variation',
    type: 'string',
    enum: ['basic', 'form'],
    defaultValue: 'basic',
    helperText: 'Choose between a simple panel with a button (basic) or one that embeds a form (form).',
  },
  {
    name: 'heading',
    type: 'string',
    defaultValue: 'Subscribe to Our Blog',
    helperText: 'Main title of the panel. Use a short, engaging headline.',
  },
  {
    name: 'description',
    type: 'string',
    defaultValue: 'Stay up to date with our latest resource and articles',
    helperText: 'Supporting text displayed below the heading. Keep it concise and clear.',
  },
  {
    name: 'theme',
    type: 'string',
    enum: ['dark', 'green'],
    defaultValue: 'dark',
    helperText: 'Select the visual theme for the panel: dark or green.',
  },
  ...formFields("options.get('variation') === 'form'"),
  {
    name: 'button',
    type: 'object',
    subFields: buttonFields,
    helperText: 'Configure the button label, URL, and style (only used in the "basic" variation).',
  },
  {
    name: 'standalone',
    type: 'boolean',
    defaultValue: false,
    helperText:
      'Wrap the panel in a full-width section so it can stand alone on a normal page. Leave off when using it inside a sidebar/feed or a blog/article body.',
  },
  ...sectionFields,
] as const satisfies DeepReadonly<Input[]>;

const resourceConversionPanelConfig = {
  name: 'ResourceConversionPanel',
  inputs: resourceConversionPanelFields,
};

export interface ResourceConversionPanelConfigProps
  extends Omit<GenerateBuilder<typeof resourceConversionPanelFields>, 'form'>, FormFieldProps, SectionConfigProps {}

export default resourceConversionPanelConfig;
